import React, { useEffect, useState } from 'react';
const promos = ['Putting Plastic Out of Play.', 'Sip Sustainably. Play Joyfully.', 'Small choices. Lasting impact.'];
export function PromoBar() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % promos.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-green text-white py-2.5 px-4" data-id="element-178">
      <div className="max-w-7xl mx-auto text-center" data-id="element-179">
        <p className="text-sm font-medium tracking-wide" data-id="element-180">
          {promos[currentIndex]}
        </p>
      </div>
    </div>;
}